import { Box } from "@mui/material";
import { ReactNode } from "react";
import WizardSidebar from "./WizardSidebar";
import WizardHeader from "./WizardHeader";
import WizardFooter from "./WizardFooter";
import { passtrackColors } from "../theme";

interface WizardShellProps {
  step: number;
  onGoToStep: (step: number) => void;
  completedSteps?: Record<number, boolean>;
  footerNote: string;
  nextDisabled: boolean;
  nextLabel?: string;
  onBack: () => void;
  onNext: () => void;
  editMode?: boolean;
  editPropertyName?: string;
  editDocumentId?: string;
  children: ReactNode;
}

export default function WizardShell({
  step,
  onGoToStep,
  completedSteps,
  footerNote,
  nextDisabled,
  nextLabel,
  onBack,
  onNext,
  editMode = false,
  editPropertyName,
  editDocumentId,
  children,
}: WizardShellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        background: passtrackColors.mist,
      }}
    >
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <WizardSidebar
          step={step}
          onGoToStep={onGoToStep}
          completedSteps={completedSteps}
        />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <WizardSidebar
            step={step}
            onGoToStep={onGoToStep}
            completedSteps={completedSteps}
            horizontal
          />
        </Box>

        <WizardHeader step={step} />

        <Box
          component="section"
          sx={{ flex: 1, minHeight: 0, overflow: "auto", px: { xs: 2.5, md: 5 }, py: 4, pb: 15 }}
        >
          {children}
        </Box>

        <WizardFooter
          step={step}
          footerNote={footerNote}
          nextDisabled={nextDisabled}
          nextLabel={nextLabel}
          onBack={onBack}
          onNext={onNext}
          editMode={editMode}
          editPropertyName={editPropertyName}
          editDocumentId={editDocumentId}
        />
      </Box>
    </Box>
  );
}
